import React from "react";
import get from "lodash/get";
import { SocialShare, StoryElement } from "@quintype/components";
import PropTypes from "prop-types";
import Dailymotion from "react-dailymotion";
import YouTube from "react-youtube";
import getYouTubeID from "get-youtube-id";

import { StickySocialShareTemplate } from "./../sticky-social-share";
import { StoryHeader } from "../story-header";
import { AuthorDetails } from "../author-details";
import { StoryCardStack } from "../story-card-stack";
import { StoryTags } from "../story-tag";
import { MostPopular } from "../most-popular";
import { MetypeCommentWrapper } from "../../metype-comments";
import { DfpAd } from "../../dfp-ad/";
import humanizeDate from "../../utils/time-format";
import { EngagementCount } from "../../basic/engagement-count";
// import { DFPAdsHorizontal } from "../../dfp-ad-horizontal";
import { ViqeoEmbed } from "../viqeo-embed";
import AlsoWatch from "../also-watch";
import TaboolaAd from "../../taboola-ad";
import "./styles.m.css";

function getPrimaryVideo(cards) {
  const headerVideo = [];
  cards.forEach(function(card) {
    card["story-elements"].forEach(function(element) {
      if (element["type"] === "youtube-video" || element["subtype"] === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });
  return headerVideo[0];
}

function getCards(story, primaryVideoID) {
  let storyCards = story.cards.map(card => {
    const newCard = Object.assign({}, card);
    let elements = card["story-elements"].filter(element => element.id !== primaryVideoID);
    newCard["story-elements"] = elements;
    return newCard;
  });
  story.cards = storyCards;
  return story;
}

const DmPlayer = ({ element }) => {
  const videoId = get(element, ["metadata", "video-id"], null);

  return (
    <div>
      <Dailymotion video={videoId} autoplay />
    </div>
  );
};

DmPlayer.propTypes = {
  element: PropTypes.object
};

const YoutubePlayer = ({ element }) => {
  const options = {
    playerVars: {
      autoplay: 1,
      mute: 1
    }
  };

  const onReady = e => {
    e.target.playVideo();
  };

  return <YouTube videoId={getYouTubeID(element.url)} opts={options} onReady={onReady} />;
};

YoutubePlayer.propTypes = {
  element: PropTypes.object
};

export class VideoStoryTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      renderMetype: false,
      renderColombia: false
    };
  }

  componentDidMount() {
    this.setState({
      renderMetype: true
    });
  }

  render() {
    const author = {
      name: get(this.props.story, ["authors", 0, "name"], this.props.story["author-name"]),
      id: get(this.props.story, ["authors", 0, "id"], this.props.story["author-id"]),
      twitter: get(this.props.story, ["authors", 0, "twitter-handle"]),
      avatarUrl: get(this.props.story, ["authors", 0, "avatar-url"]),
      slug: get(this.props.story, ["authors", 0, "slug"]),
      "avatar-s3-key": get(this.props.story, ["authors", 0, "avatar-s3-key"])
    };

    const story = Object.assign({}, this.props.story);
    const primaryVideo = getPrimaryVideo(story.cards);
    const storyProps = primaryVideo ? getCards(story, primaryVideo.id) : this.props.story;
    let renderTemplates = {};

    if (primaryVideo.subtype === "dailymotion-video") {
      renderTemplates = { "dailymotion-video": DmPlayer };
    } else if (primaryVideo.type === "youtube-video") {
      renderTemplates = { "youtube-video": YoutubePlayer };
    }

    return (
      <div styleName="videostory">
        <div>
          <StoryElement element={primaryVideo} story={this.props.story} renderTemplates={renderTemplates} />
          <StoryHeader story={this.props.story} />
          <div styleName="story-body">
            <SocialShare
              template={StickySocialShareTemplate}
              title={this.props.story.headline}
              url={this.props.story.slug}
              color="#fff"
            />
            <div styleName="story-content">
              <div styleName="author-wrapper">
                <div>
                  <AuthorDetails
                    author={author}
                    storyFirstPublishedDate={this.props.story["first-published-at"]}
                    storyLastPublishedDate={this.props.story["last-published-at"]}
                  />
                </div>
                <EngagementCount storyId={this.props.story.id} />
              </div>
              <StoryCardStack story={storyProps} />
              <center>
                <DfpAd adtype="NH_E_Body" />
              </center>
              <br />
              <ViqeoEmbed />
              <StoryTags tags={this.props.story.tags} />
              <span>
                {this.props.story["first-published-at"] !== this.props.story["last-published-at"]
                  ? `Published: ${humanizeDate(this.props.story["first-published-at"])}`
                  : null}
              </span>
              {/* <ViqeoEmbed /> */}
            </div>
          </div>
          {/* <DFPAdsHorizontal /> */}
          {this.state.renderMetype && (
            <MetypeCommentWrapper metypeConfig={this.props.metypeConfig} story={this.props.story} />
          )}
          <AlsoWatch />
          <TaboolaAd container="taboola-below-article-thumbnails" placement="Below Article Thumbnails" />
        </div>
        <div>
          <div styleName="dfp">
            <DfpAd adtype="NH_300x250" />
          </div>
          <MostPopular
            mostPopular={this.props.mostPopular}
            id={this.props.story.id}
            metypeConfig={this.props.metypeConfig}
            hideIcon
          />
          <div styleName="dfp">
            <DfpAd adtype="NH_MP_300x600" />
          </div>
        </div>
      </div>
    );
  }
}

function VideoStory(props) {
  return (
    <div className="story-grid">
      <VideoStoryTemplate story={props.story} mostPopular={props.mostPopular} metypeConfig={props.metypeConfig} />
    </div>
  );
}

export { VideoStory };
VideoStoryTemplate.propTypes = {
  mostPopular: PropTypes.Array,
  story: PropTypes.shape({
    "author-name": PropTypes.string,
    "author-id": PropTypes.number,
    headline: PropTypes.string,
    slug: PropTypes.string,
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    cards: PropTypes.Array,
    tags: PropTypes.Array,
    id: PropTypes.string
  }),
  metypeConfig: PropTypes.object
};
VideoStory.propTypes = {
  story: PropTypes.object,
  mostPopular: PropTypes.Array,
  metypeConfig: PropTypes.object
};
